import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getSafe } from '../../../../shared/utility';
import RFB from 'novnc-core-window';
import { Button, Form, Input } from 'antd';
import Modal from '../../../../components/UI/Modal/Modal';
import { ReconciliationOutlined } from '@ant-design/icons';
import * as STATE_PATHS from '../../../../shared/const/Routes/statePaths';

import './VncClient.scss';

const STATUS = 'connected';
const DISCONNECTED = 'disconnected';
const CANVAS_ID = 'canvas';
const SECURE_URL_PREFIX = 'wss';
const INSECURE_URL_PREFIX = 'ws';
const CLIPBOARD_TITLE = 'Clipboard';
const OK_TEXT = 'Send';
const CLIPBOARD_LAYOUT = 'vertical';
const CLIPBOARD_LABEL = 'Send to clipboard';
const TYPE = 'textarea';
const PLACEHOLDER = 'Type text to send to clipboard';
const CONNECT_EVENT_LISTENER = 'connect';
const CLIPBOARD_EVENT_LISTENER = 'clipboard';
const DISCONNECT_EVENT_LISTENER = 'disconnect';
const COPY_LISTENER_ATTRIBUTE = 'copy';
const theClipboard = navigator.clipboard;

const VncClient = props => {
  const { jobId, vncDisplay, host, port, password, path, isSecure, ...opts } =
    props;
  const [status, setStatus] = useState(STATUS);
  const [visible, setVisible] = useState(false);
  const [clipboardText, setClipboardText] = useState('');
  const [rfb, setrfb] = useState(null);
  const externalWindows = useSelector(state =>
    getSafe(STATE_PATHS.EXTERNAL_WINDOWS, state)
  );

  useEffect(() => {
    if (rfb == null) {
      connect();
    }
  }, [externalWindows[jobId]]);

  useEffect(() => {
    if (rfb) {
      rfb.addEventListener(CONNECT_EVENT_LISTENER, addCopyListener);
      rfb.addEventListener(CLIPBOARD_EVENT_LISTENER, e => {
        copyFromVNC(e.detail.text);
      });
      rfb.addEventListener(DISCONNECT_EVENT_LISTENER, opts.onDisconnect);
      externalWindows[jobId].window.addEventListener('unload', disconnect);
    }
  }, [rfb]);

  const addCopyListener = () => {
    document.body.addEventListener(COPY_LISTENER_ATTRIBUTE, function (e) {
      theClipboard.readText().then(result => {
        sendToClipboard(result);
      });
    });
  };

  const copyFromVNC = text => {
    externalWindows[jobId].navigator.clipboard.writeText(text);
  };

  const disconnect = () => {
    if (!rfb || rfb._rfb_connection_state == DISCONNECTED) {
      return;
    }
    rfb.disconnect();
    setrfb(null);
  };

  const connect = () => {
    // Build the websocket URL used to connect
    let url = '';

    if (isSecure) {
      url = SECURE_URL_PREFIX;
    } else {
      url = INSECURE_URL_PREFIX;
    }

    url += '://' + host;
    if (port) {
      url += ':' + port;
    }
    url += '/' + path;

    // Creating a new RFB object will start a new connection
    if (externalWindows[jobId]) {
      let newRFB = new RFB(
        externalWindows[jobId].document.getElementById(CANVAS_ID),
        url,
        {
          // credentials: { password: password },
        },
        externalWindows[jobId]
      );
      setrfb(newRFB);
    }
  };

  const sendToClipboard = text => {
    rfb.clipboardPasteFrom(text);
  };

  const showModal = () => {
    setVisible(true);
  };

  const handleSend = () => {
    sendToClipboard(clipboardText);
    setClipboardText('');
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const updateClipboardText = e => {
    setClipboardText(e.target.value);
  };

  const getClipboard = () => {
    return (
      <div className="clipboard">
        <Button onClick={showModal}>
          <ReconciliationOutlined /> Clipboard
        </Button>
        <Modal
          visible={visible}
          title={CLIPBOARD_TITLE}
          okText={OK_TEXT}
          onCancel={handleCancel}
          onOk={handleSend}
          jobId={jobId}
        >
          <Form layout={CLIPBOARD_LAYOUT}>
            <Form.Item label={CLIPBOARD_LABEL}>
              <Input
                value={clipboardText}
                onChange={updateClipboardText}
                type={TYPE}
                placeholder={PLACEHOLDER}
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  };

  const alternativeVNC = () => {
    return (
      <div className="clipboard">
        <Button
          key="realvnc-connect"
          onClick={() => {
            const vncUrl = `com.realvnc.vncviewer.connect://${vncDisplay}`;
            window.open(vncUrl, '_blank');
          }}
        >
          RealVnc Connect
        </Button>
      </div>
    );
  };

  return (
    <div className="vncContainer">
      {props.actionsBar &&
        props.actionsBar({
          status: status,
          onDisconnect: disconnect,
          getClipboard: getClipboard,
          alternativeVNC: alternativeVNC,
        })}

      <div id={CANVAS_ID} className="canvas">
        {/* This is where the remote screen will appear */}
      </div>
    </div>
  );
};

export default VncClient;
